import React from 'react';
import { useTranslation } from 'react-i18next';
import style from "../../css/Recharge.module.css";
import Cookies from 'js-cookie';

function PaymentTab({
    soTien,
    showCustomInput,
    handleAmountClick,
    setSoTien,
    promoCode,
    setPromoCode,
    handleRecharge,
    errors,
    isPromoApplied,
    handleApplyPromo,
    handleCancelPromo,
    promoteAmount,
    promoApplied,
    totalTopup,
    selectedOption
}) {
    const { t } = useTranslation();
    const promocode = "TIDADIGI2000K"; // Define promo code

    return (
        <div className={style.paymentContainer}>
            <p className="text-center fw-bold"></p>
            <div className="row justify-content-center">
                <div className="col-md-6 mb-4">
                    <label className="form-label fw-semibold">
                        {t("Add funds")}
                    </label>
                    <div className={style.buttonGroup}>
                        {[100000, 200000, 500000, 700000, 1000000].map((amount) => (
                            <button
                                key={amount}
                                type="button"
                                className={`${style.button} ${soTien === amount && !showCustomInput ? style.buttonActive : ""}`}
                                onClick={() => handleAmountClick(amount)}
                            >
                                {amount.toLocaleString()}
                            </button>
                        ))}
                        <button
                            onClick={() => handleAmountClick("other")}
                            type="button"
                            className={`${style.button} ${showCustomInput ? style.buttonActive : ""}`}
                        >
                            {t("Other")}
                        </button>
                    </div>

                    {showCustomInput && (
                        <input
                            type="number"
                            className="form-control mt-2"
                            placeholder={t("Enter amount...")}
                            min="100000"
                            value={soTien}
                            style={{ width: '70%' }}
                            onChange={(e) => setSoTien(e.target.value)}
                            required
                        />
                    )}
                    <div className="my-3">
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={handleRecharge}
                        >
                            {t("Add funds")}
                        </button>
                    </div>

                    {errors && <p className="text-danger mt-1">{errors}</p>}
                </div>

                <div className="col-md-5 mb-4">
                    <label className="form-label fw-semibold">
                        {t("Summary")}
                    </label>
                    <div className="input-group">
                        <input
                            type="text"
                            className="form-control"
                            placeholder={t("Enter promo code")}
                            style={{ width: '70%' }}
                            value={promoCode}
                            onChange={(e) => setPromoCode(e.target.value)}
                            required
                        />
                        <button
                            className="btn btn-primary"
                            style={{ width: '30%' }}
                            onClick={handleApplyPromo}
                        >
                            {t("Apply")}
                        </button>
                    </div>

                    {selectedOption === "Credit Card" && errors && (
                        <p className="text-danger mt-1">{errors}</p>
                    )}

                    <div style={{ margin: "0px", padding: "0px" }} className="col-12">
                        <div className="border p-3 rounded" style={{ backgroundColor: "#f9f9f9" }}>
                            {Cookies.get("promoApplied") === promocode && (
                                <>
                                    <div className="d-flex justify-content-between">
                                        <span>{promoApplied} </span>
                                        <span className="text-success">
                                            {new Intl.NumberFormat('vi-VN').format(promoteAmount)}{' '}
                                            <span
                                                style={{ color: "red", cursor: "pointer" }}
                                                onClick={handleCancelPromo}
                                            >
                                                {t("Delete")}
                                            </span>
                                        </span>
                                    </div>
                                    <div className="d-flex justify-content-between">
                                        <span style={{ fontSize: "13px" }}>{t("Credit expires")}</span>
                                    </div>
                                </>
                            )}

                            <div className="d-flex justify-content-between mt-2">
                                <span>{t("Amount:")}</span>
                                <span className="text-success">
                                    {new Intl.NumberFormat('vi-VN').format(soTien)}
                                </span>
                            </div>
                            <hr />
                            <div className="d-flex justify-content-between mt-2">
                                <span className="fw-semibold">{t("Total:")}</span>
                                <span className="text-success">
                                    {new Intl.NumberFormat('vi-VN').format(totalTopup())}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PaymentTab;
